enum JurisdictionSpecificInfoType {
  EMAIL_FROM_ADDRESS = 'EMAIL_FROM_ADDRESS',
  LOGO = 'LOGO',
  BANNER = 'BANNER',
  EMAIL_SALUTATION = 'EMAIL_SALUTATION',
  CCOC_ACQUIRER_ADDRESS = 'CCOC_ACQUIRER_ADDRESS',
  CCOC_CANCELLATION_OF_CONTRACT = 'CCOC_CANCELLATION_OF_CONTRACT',
  CCOC_COMPLAINT_HANDLING_PROCEDURES = 'CCOC_COMPLAINT_HANDLING_PROCEDURES',
  CCOC_PAYMENT_TERMINAL_PARTNER_NAME = 'CCOC_PAYMENT_TERMINAL_PARTNER_NAME',
  CCOC_PAYMENT_TERMINAL_SERVICES_PROVIDED = 'CCOC_PAYMENT_TERMINAL_SERVICES_PROVIDED',
  CCOC_URL = 'CCOC_URL',
  CCOC_STATEMENTS = 'CCOC_STATEMENTS',
  CCOC_FEE_DISCLOSURES_REQUIREMENTS_URL = 'CCOC_FEE_DISCLOSURES_REQUIREMENTS_URL',
  PARTNER_LOGO = 'PARTNER_LOGO',
  EQUIPMENT = 'EQUIPMENT',
  EQUIPMENT_IMAGE = 'EQUIPMENT_IMAGE',
  CONTACT_US_MAIN = 'CONTACT_US_MAIN',
  CONTACT_US_FALLOUT = 'CONTACT_US_FALLOUT',
  CONTACT_US_SUBMIT = 'CONTACT_US_SUBMIT',
}

export default JurisdictionSpecificInfoType;
